module.exports = __webpack_public_path__ + "img/A003.cebe1701.png";